import { GlobalDE, GlobalEN } from '@cofenster/web-components';

export const Translations = {
  EN: {
    ...GlobalEN,
    'EmbeddedVideoPlayer.watchOn': 'Watch on',
    'ErrorPage.NotFound.title': 'The video you are looking for is currently not available',
    'ErrorPage.NotFound.subtitle':
      'It might have been removed by the creator or there could be a typing error in your link.',
    'ErrorPage.ServerError.reloadButton': 'Reload',
    'ErrorPage.ServerError.title': 'An error happened on our end',
    'ErrorPage.ServerError.subtitle': 'Sorry about that. Please try reloading the page.',
    'PageFooter.dataProtection': 'Data Protection',
    'PageFooter.imprint': 'Imprint',
    'PageFooter.terms': 'Terms',
    'VideoPage.common.share': 'Share',
    'VideoPage.videoIsNotPublic': 'This video is not public',
    'VideoPage.shareVideo': 'Share this video',
  },
  DE: {
    ...GlobalDE,
    'EmbeddedVideoPlayer.watchOn': 'Anschauen auf',
    'ErrorPage.NotFound.title': 'Das Video nach dem du suchst ist aktuell nicht verfügbar',
    'ErrorPage.NotFound.subtitle':
      'Es könnte vom Ersteller entfernt worden sein, oder es gibt einen Fehler in deinem Link.',
    'ErrorPage.ServerError.reloadButton': 'Erneut laden',
    'ErrorPage.ServerError.title': 'Auf unserer Seite ist uns ein Fehler unterlaufen',
    'ErrorPage.ServerError.subtitle': 'Das tut uns leid. Bitte versuche die Seite neu zu laden.',
    'PageFooter.dataProtection': 'Datenschutz',
    'PageFooter.imprint': 'Impressum',
    'PageFooter.terms': 'AGB',
    'VideoPage.common.share': 'Teilen',
    'VideoPage.videoIsNotPublic': 'Dieses Video ist nicht öffentlich.',
    'VideoPage.shareVideo': 'Teile dieses Video',
  },
};
